let toFixed=(input,num)=>Number(input).toFixed(num)
 
export default {toFixed}//默认导出


// WEBPACK FOOTER //
// ./src/common/filter/filter.js